import { render } from "./Unregister.vue?vue&type=template&id=b984a36c"
import script from "./Unregister.vue?vue&type=script&lang=js"
export * from "./Unregister.vue?vue&type=script&lang=js"

import "./Unregister.vue?vue&type=style&index=0&id=b984a36c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__